<template>
  <div>
    <!-- h5页面 -->
    <div class="product">
      <h1 class="title">产品中心</h1>
      <section class="wrap">
        <div class="item" v-for="(item,index) in list" :key="index">
          <img class="img" :src="item.info2" alt />
          <p class="item-title">{{item.info3}}</p>
          <div class="detail">
            <span class="price">&#165;{{item.info4}}</span>
            <button @click="go(item)">马上抢</button>
          </div>
        </div>
      </section>
    </div>
    <!-- pc页面 -->
    <div class="product-pc">
      <div class="product-wrap">
        <header class="header">
          <h1 class="title">产品中心</h1>
          <div class="set" v-show="list.length>4">
            <div class="product-prev prev" slot="button-prev"></div>
            <div class="product-next next" slot="button-next"></div>
          </div>
        </header>
        <!-- 产品轮播图 -->
        <div class="swiper-wrap">
          <swiper :options="swiperOptionTop" class="gallery-top">
            <swiper-slide :key="index" v-for="(item ,index) in list">
              <div class="item">
                <img class="img" :src="item.info2" alt />
                <p class="item-title">{{item.info3}}</p>
                <div class="detail">
                  <span class="price">&#165;{{item.info4}}</span>
                  <button @click="go(item)">马上抢</button>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

import XHR from '../api'

export default {
  name: 'Product',
  props: [],
  data: () => ({
    list: [], // 产品列表
    swiperOptionTop: {
      slidesPerView: 4, // 视图内最大数
      spaceBetween: 60, // 间隔
      navigation: {
        nextEl: '.product-next',
        prevEl: '.product-prev'
      }
    }
  }),
  components: {
    swiper,
    swiperSlide
  },
  created () {
  },
  mounted () {
    this.getHandWork()
  },
  methods: {
    // 手工位
    getHandWork () {
      XHR.getHandWork({
        type: 40,
        hid: 4120
      }).then(res => {
        const { status, data } = res.data
        if (!status) {
          this.list = data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    go (item) {
      this.sendAnalytics('配件新零售招商专题活动', '查看配件', item.info3)
      window.location.href = item.info1
    }
  }
}
</script>
<style lang="less" scoped>
.product {
  position: relative;
  width: 100%;
  background-color: #ffffff;
  .title {
    font-size: 24px;
    color: #000000;
    line-height: 30px;
    padding: 28px 0 20px;
    text-align: center;
  }
  .wrap {
    display: flex;
    flex-wrap: wrap;
    padding: 0 28px;
    justify-content: space-between;
    .item {
      width: 142px;
      height: 200px;
      text-align: center;
      margin-bottom: 28px;
      .img {
        width: 120px;
        height: 120px;
      }
      .item-title {
        font-size: 14px;
        text-align: left;
        margin-top: 12px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .detail {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 4px;
        .price {
          font-size: 14px;
          color: #ff4242;
        }
        button {
          width: 52px;
          height: 24px;
          background-image: linear-gradient(270deg, #3d83ff 0%, #3a48db 100%);
          box-shadow: 0 4px 8px 0 rgba(61, 114, 245, 0.4);
          border-radius: 12px;
          font-size: 12px;
          color: #ffffff;
          line-height: 24px;
        }
      }
    }
  }
}
.product-pc {
  width: 100%;
  margin-bottom: 40px;
  .product-wrap {
    width: 1200px;
    margin: auto;
    .header {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .title {
        font-size: 40px;
        color: #000000;
        text-align: left;
        line-height: 50px;
        padding: 60px 0 30px 0;
      }
      .set {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 30px;
        .prev {
          display: inline-block;
          width: 30px;
          height: 30px;
          background: #3d72f5;
          text-align: center;
          line-height: 30px;
          color: #ffffff;
          font-size: 12px;
          outline: none;
          transition: background 0.1s;
          &:hover {
            background: #09dda8;
          }
          &::before {
            content: "\e7fa";
            display: inline-block;
            font-family: "iconfont";
          }
        }
        .next {
          display: inline-block;
          width: 30px;
          height: 30px;
          background: #3d72f5;
          text-align: center;
          line-height: 30px;
          color: #ffffff;
          font-size: 12px;
          outline: none;
          margin-left: 10px;
          transition: background 0.1s;
          &:hover {
            background: #09dda8;
          }

          &::before {
            content: "\e7fb";
            display: inline-block;
            font-family: "iconfont";
          }
        }
      }
    }

    .swiper-wrap {
      .item {
        width: 252px;
        text-align: center;
        padding-bottom: 20px;
        .img {
          width: 200px;
          height: 200px;
        }
        .item-title {
          text-align: left;
          margin-top: 20px;
          font-size: 18px;
          color: #000000;
          line-height: 24px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .detail {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          .price {
            font-size: 18px;
            color: #ff4242;
          }
          button {
            cursor: pointer;
            width: 70px;
            height: 30px;
            background-image: linear-gradient(270deg, #3d83ff 0%, #3a48db 100%);
            box-shadow: 0 4px 8px 0 rgba(61, 114, 245, 0.4);
            border-radius: 15px;
            font-size: 14px;
            color: #ffffff;
            line-height: 30px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 376px) {
  .product-pc {
    display: block;
  }
  .product {
    display: none;
  }
}
@media screen and (max-width: 375px) {
  .product-pc {
    display: none;
  }
  .product {
    display: block;
  }
}
</style>
